<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Material CATMAT"
    >
        <rkm-row>
            <rkm-col cols="12">
                <rkm-form-input-autocomplete
                    :repository="repositories.materialBnafar"
                    :search-fields="fields"
                    :text-field="(p) => `${p.descricao} - ${tipoDescricao(p.tipo)}`"
                    :validations="validations.materialBnafar"
                    resultsLimit="50"
                    label="Cadastro de materiais (CATMAT)"
                    v-model="model.materialBnafar"
                />
            </rkm-col>
        </rkm-row>

         <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Cancelar
            </rkm-button>

            <rkm-button
                @click="update"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {error, object, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        fields() {
            return [
                {key: 'descricao', searchable: true},
            ]
        },
        validations() {
            return {
                materialBnafar: {
                    required: true,
                },
            }
        },
    },
    created() {
        this.repositories = {
            material: this.getConectaSusRepository('cadastro.material'),
            materialBnafar: this.getConectaSusRepository('cadastro.materialBnafar'),
        }
    },
    data: () => ({
        materialId: null,
        model: {
            materialBnafar: null,
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(materialId) {
            this.materialId = materialId

            this.resetForm()

            this.$refs.RkmModal.show()

            this.load()
        },
        load() {
            this.setLoading()

            this.repositories.material.editMaterialBnafar(this.materialId)
                .then((response) => {
                    if (response.data.id) {
                        this.model.materialBnafar = response.data
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        update() {
            const request = {
                materialBnafarId: this.model.materialBnafar.id,
            }

            this.setLoading()

            this.repositories.material.updateMaterialBnafar(this.materialId, this.camelObjectKeysToSnakeRecursive(request))
                .then((response) => {
                    this.showSaveNotification()

                    this.$emit('save', response.data)

                    this.$refs.RkmModal.hide()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        resetForm() {
            this.model.materialBnafar = null
        },
        tipoDescricao(tipo) {
            switch (tipo) {
                case 'B':
                    return 'Básico';
                case 'E':
                    return 'Especializado';
                case 'S':
                    return 'Estratégico';
                case 'O':
                    return 'Outros';
                default:
                    return 'Desconhecido';
            }
        },
    },
    mixins: [error, object, repository, stringCase],
}
</script>